import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {
  BiointelligentLinkContainerCountQuery,
  BiointelligentLinkContainerCountQueryVariables,
} from 'molbio/biointelligent-links/__generated/BiointelligentLinkContainerCountQuery';
import {BIOINTELLIGENT_LINK_CONTAINER_COUNT_QUERY} from 'molbio/biointelligent-links/BiointelligentLinkQueries';
import OptionsBanner from 'molbio/maps/options/OptionsBanner';
import {Optional} from 'util/Types';

interface SequenceOptionsBannerProps {
  overrideBannerText: Optional<React.ReactNode>;
  sequenceId: string;
}

export default function SequenceOptionsBanner({
  overrideBannerText,
  sequenceId,
}: SequenceOptionsBannerProps): JSX.Element {
  const queryResult = useSkippableBenchlingQuery<
    BiointelligentLinkContainerCountQuery,
    BiointelligentLinkContainerCountQueryVariables
  >(BIOINTELLIGENT_LINK_CONTAINER_COUNT_QUERY, {
    skip: overrideBannerText != null || !BenchlingConfig.MOLBIO_ENABLE_EDITING_BIOINTELLIGENT_LINKS,
    variables: {id: sequenceId},
  });
  if (
    queryResult.type === QueryResultType.SUCCESS &&
    queryResult.data.polymer.__typename === 'SequenceNode'
  ) {
    const {polymer} = queryResult.data;
    if (polymer.partContainerCount > 0 || polymer.transcriptionContainerCount > 0) {
      return <OptionsBanner bannerText="Editing is disabled on linked sequences." />;
    }
  }
  return <OptionsBanner bannerText={overrideBannerText} />;
}
